import React from "react";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import Flag from "react-flagkit";

const AddressCard = ({ address, onEdit, onDelete }) => {
    return (
        <div
            className={`card bg-base-100 shadow-sm hover:shadow-md transition-shadow duration-200 ${
                address.isPrimary ? "border-2 border-primary" : "border"
            }`}
        >
            <div className="card-body p-3">
                <div className="flex justify-between items-start">
                    <div className="space-y-1">
                        <p className="font-medium text-sm leading-tight">{address.street}</p>
                        <p className="text-xs text-gray-600">{address.city}, {address.postcode}</p>
                        <p className="text-xs text-gray-600">{address.state}</p>
                        <div className="flex flex-row items-center gap-1 mt-1">
                            <Flag country={address.isoCountry} size={16} className="flex-shrink-0" />
                            <span className="text-xs text-gray-600">{address.country}</span>
                            {address.isPrimary && (
                                <span className="badge badge-primary badge-sm ml-1 text-xs">Défaut</span>
                            )}
                        </div>
                    </div>
                    <div className="flex gap-1">
                        <button
                            onClick={() => onEdit(address.id)}
                            className="btn btn-ghost btn-xs h-7 min-h-0"
                            aria-label={`Modifier l'adresse ${address.street}`}
                        >
                            <PencilIcon className="w-3.5 h-3.5" />
                        </button>
                        <button
                            onClick={() => onDelete(address.id)}
                            className="btn btn-ghost btn-xs h-7 min-h-0 text-error"
                            aria-label={`Supprimer l'adresse ${address.street}`}
                        >
                            <TrashIcon className="w-3.5 h-3.5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddressCard; 